import {
  CandleFetchParams,
  CandlePoint,
  ExchangeCandleRestAdapter,
} from "../../candle.types";
import { toBinanceInterval } from "../../candle-intervals";
import { normalizeCandleSymbol } from "../../candle-symbols";
import {
  dedupeCandles,
  throwHttpError,
} from "./rest-adapter.utils";

type BinanceKline = [
  number,
  string,
  string,
  string,
  string,
  string,
  number,
  string,
  number,
  string,
  string,
  string
];

const BINANCE_URL = "https://fapi.binance.com/fapi/v1/klines";
const DEFAULT_LIMIT = 500;
const MAX_LIMIT = 1500;

export const binanceCandlesRestAdapter: ExchangeCandleRestAdapter = {
  async fetchCandles(params: CandleFetchParams): Promise<CandlePoint[]> {
    const symbol = normalizeCandleSymbol("binance", params.symbol);
    const query = new URLSearchParams({
      symbol,
      interval: toBinanceInterval(params.interval),
      limit: String(Math.min(params.limit ?? DEFAULT_LIMIT, MAX_LIMIT)),
    });

    if (params.startTime) query.set("startTime", String(params.startTime));
    if (params.endTime) query.set("endTime", String(params.endTime));

    const response = await fetch(`${BINANCE_URL}?${query.toString()}`);
    if (!response.ok) {
      throwHttpError(response, "binance");
    }

    const payload = (await response.json()) as BinanceKline[];
    const candles: CandlePoint[] = payload.map((kline) => ({
      startTime: kline[0],
      openPrice: kline[1],
      highPrice: kline[2],
      lowPrice: kline[3],
      closePrice: kline[4],
      volume: kline[5],
    }));

    return dedupeCandles(candles);
  },
};

